<template>
  <div class="basic-data">
      <!-- tab -->
      <div class="tab-header">
        <label :for="item.contentId" @click="toggleTab(index,item.contentId)" v-for="(item,index) in headList" :key="index">
            {{item.title}}
            <img v-if="item.contentId==activeTab" src="@a/topS3.png" />
        </label>
      </div>
      <div class="tab-content">
          <!-- 基础信息 -->
          <div id="basic1" v-if="activeTab =='basic1'">
            <h3>小组项目完成率</h3>
            <table class="table">
                <tr class="on">
                    <td>项目名称</td>
                    <td>测验题完成率</td>
                    <td>任务完成率</td>
                </tr>
                <tr v-for="(item,index) in list" :key="index">
                    <td class="text-ellipsis">{{item.name}}</td>
                    <td>{{item.test_rate}}</td>
                    <td>{{item.task_rate}}</td>
                </tr>
            </table>
            <!-- 温馨提示 -->
            <p>温馨提示：<br/>项目的测验题完成率、任务完成率为系统自行计算，不需要进行操作；</p>
          </div>
          <!-- 学员资料 -->
          <div id="basic2" v-if="activeTab == 'basic2'">
            <h3>小组学员作业完成情况（共：{{user_list && user_list.length}}人）</h3>
            <div class="tb-group">
                <!-- 左侧固定表格 -->
                <div class="left-tb">
                    <table>
                        <tr>
                            <td>序号</td>
                            <td class="on">姓名</td>
                        </tr>
                        <tr class="tr2" v-for="(item,index) in user_list" :key="index">
                            <!--  class="text-ellipsis" -->
                            <td>{{index+1}}</td>
                            <td>
                                <img :src="item.headimgurl" /><br/>
                                {{item.name?item.name:item.nickname}}
                            </td>
                        </tr>
                    </table>
                </div>
                <!-- 右侧滚动表格 -->
                <div class="right-tb">
                    <table>
                        <tr>
                            <template v-for="(item,index) in level_list">
                                <td :key="index">{{splitTableHead(item.name)+'测验'}}</td>
                                <td :key="index">{{splitTableHead(item.name)+'关卡'}}</td>
                            </template>
                        </tr>
                        <tr  class="tr2" v-for="(item,index) in user_list" :key="index">
                            <template v-for="(itm2,idx2) in level_list">
                                <td :key="idx2">{{item.test_done[itm2.id]}}</td>
                                <td :key="idx2">
                                    <span v-if="item.task_done[itm2.id]!='已完成'">{{item.task_done[itm2.id]}}</span>
                                    <router-link v-else :to="{
                                        path:'/ta_project_report',
                                        query:{
                                            cid:$route.query.course_id,
                                            cpid:itm2.task_cpid,
                                            uid:item.uid
                                        }
                                    }">
                                        查看
                                    </router-link>
                                </td>
                            </template>
                        </tr>
                    </table>
                </div>
            </div>
          </div>
          <!-- 每日一问 -->
          <div id="basic3" v-if="activeTab == 'basic3'">
            <h3>小组每日一问完成率</h3>
            <div class="tb-group">
                <!-- 左侧固定表格 -->
                <div class="left-tb">
                    <table>
                        <tr>
                            <td class="on">名称</td>
                        </tr>
                        <tr class="tr2" v-for="(item,index) in askADayList" :key="index">
                            <td>
                                {{`第${conversion(item.idx)}周`}}
                            </td>
                        </tr>
                    </table>
                </div>
                <!-- 右侧滚动表格 -->
                <div class="right-tb">
                    <table>
                        <tr>
                            <template v-for="(item,index) in 5">
                                <td :key="index">{{`第${item}天`}}</td>
                            </template>
                            <td>合计</td>
                        </tr>
                        <tr  class="tr2" v-for="(item,index) in askADayList" :key="index">
                            <td v-for="(itm,idx) in item.day" :key="idx">
                                <input  type="text" @change="blurChange(item,index,item.idx)"    v-model.number="item.day[idx]" />
                            </td>
                            <td>{{`${item.avg}%`}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="addBasic3">
                <img @click="addBasic3()" src="@a/ta_information.png" >增加一条数据
                <span >
                    <img  @click="confirmShow=true" class="two" src="@a/ta_remove_info.png" >删除一条数据
                </span>
            </div>
            <!-- 温馨提示 -->
            <p>温馨提示：<br/>1、名称可进行编辑，示例：“第一周每日一问完成率”依次类推；<br/>2、第一天、第二天...下方的完成率点击文本框输入即可；<br/>3、本周完成率不需要填写，系统自动计算；<br/>4、点击“增加一条数据”会自动添加一条类目，按照以上要求填写即可；</p>
          </div>
          <div id="basic4" v-if="activeTab == 'basic4'">
            <h3>小组讨论出勤率</h3>
            <div class="tb-group">
                <!-- 左侧固定表格 -->
                <div class="left-tb">
                    <table>
                        <tr>
                            <td class="on">名称</td>
                        </tr>
                        <tr class="tr2" v-for="(item,index) in groupDiscussion" :key="index">
                            <td>
                                {{`第${conversion(item.idx)}周出勤率`}}
                            </td>
                        </tr>
                    </table>
                </div>
                <!-- 右侧滚动表格 -->
                <div class="right-tb">
                    <table width="100%">
                        <tr>
                            <template v-for="(item,index) in 2">
                                <td :key="index">{{`第${item}次`}}</td>
                            </template>
                            <td>本周出勤率</td>
                        </tr>
                        <tr  class="tr2" v-for="(item,index) in groupDiscussion" :key="index">
                            <td v-for="(itm,idx) in item.day" :key="idx">
                                <input  type="text" @change="discBlurChange(item,index,item.idx)"   v-model.number="item.day[idx]" />
                            </td>
                            <td>{{`${item.avg}%`}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="addBasic4">
                <img @click="addBasic4()" src="@a/ta_information.png" >增加一条数据
                <span >
                    <img  @click="confirmShow=true" class="two" src="@a/ta_remove_info.png" >删除一条数据
                </span>
            </div>
            <!-- 温馨提示 -->
            <p>温馨提示：<br/>1、名称可进行编辑，示例：“第一周小组讨论出勤率”依次类推；<br/>2、第一次、第二次下方的完成率点击文本框输入即可，如果只有一次讨论只填写第一次即可；<br/>3、本周出勤率不需要填写，系统自动计算；<br/>4、点击“增加一条数据”会自动添加一条类目，按照以上要求填写即可；</p>
          </div>
      </div>
      <!-- 确认提交弹窗 -->
    <van-popup class="pub_alert" v-model="confirmShow">
      <div class="confirm_box">
        <h2>是否确认删除</h2>
        <div class="btn_group">
          <a class="confirm on" href="javascript:;" @click="removeBasic3()">确认</a>
          <a class="cancel" href="javascript:;" @click="confirmShow=false">取消</a>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getBasicData,getUserData,getQuizStatList,updateQuizStat,deleteStat,getDiscStatList,updateDIscStat } from "@/api/course";
import { shareCon } from "@/utils/wxconfig";
import { numberToChinese,deepCopy } from "@/utils/tools";
export default {
    data(){
        return{
            activeTab:'basic1',
            headList:[],
            // 基础信息
            list:[],
            // 学员资料
            level_list:[],
            user_list:[],
            // 每日一问
            basicIdx3:null,
            askADayList:[],
            confirmShow:false,
            // 小组讨论
            basicIdx4:null,
            groupDiscussion:[]
        }
    },
    methods:{
        /*
         *@param: 
         *@return: 
         *@Description: 删除一行每日一问数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-14 10:09:23
        */
        removeBasic3(){
            
            this.confirmShow = false;
            //调用加载中
            this.$emit('loadingHandle',true,"删除数据中...");
            let obj = {};
            let idx = null;
            if(this.activeTab=='basic3'){
                idx = this.askADayList.length-1;
                let b = false;
                obj = {
                    cid:this.$route.query.course_id
                };
                // for(let i =idx;i>=0;i--){
                    if(this.askADayList[idx].id){
                        obj.id = this.askADayList[idx].id;
                        obj.idx = this.askADayList[idx].idx;
                        b=true;
                        // break;
                    }
                // }
                if(!b){
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                    // this.$toast('还未填写或提交数据！');
                    if(this.askADayList.length>0){
                        this.askADayList.splice(this.askADayList.length-1,1);
                    }
                    return;
                }
            }
            if(this.activeTab=='basic4'){
                idx = this.groupDiscussion.length-1;
                let b = false;
                obj = {
                    cid:this.$route.query.course_id
                };
                // 从数组最后一个元素开始删除
                // for(let i =idx;i>=0;i--){
                    // 根据id是否存在来判断是否有提交过数据
                    if(this.groupDiscussion[idx].id){
                        obj.id = this.groupDiscussion[idx].id;
                        obj.idx = this.groupDiscussion[idx].idx;
                        b=true;
                        // break;
                    }
                // }
                if(!b){
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                    // this.$toast('还未填写或提交数据！');
                    if(this.groupDiscussion.length>0){
                        this.groupDiscussion.splice(this.groupDiscussion.length-1,1);
                    }
                    // this.$toast('还未填写或提交数据！');
                    // console.log('groupDiscussion',this.groupDiscussion);
                    return;
                }
            }
            // 删除数据接口
            deleteStat(obj).then(data=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.code==10002){
                    this.$toast(data.data.msg);
                    return
                }

                this.$toast('删除成功！');
                // this.$forceUpdate();
                // this.$delete(this.activeTab=='basic4'?this.groupDiscussion:this.this.askADayList,idx);
                this.getData();
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 小组讨论失去焦点的时候验证是否已填写完所有数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-14 11:17:05
        */
        discBlurChange(item,index,idx){
            this.basicIdx4 = index;
            let bool = true;
            let s =0;
            let hj =0;
            for(let i=0;i<item.day.length;i++){
                if(item.day[i]){
                    s+=1
                }
                hj+=item.day[i];
            }
            item.avg = hj?hj/s:0;
            if(bool){
                item.idx = index+1;
                item.cid = this.$route.query.course_id;
                this.saveBasic4();
            }
        },
        /*
         *@param:item 行对象 index 下标  idx第几行
         *@return: 
         *@Description: 失去焦点的时候验证是否已填写完所有数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-13 17:32:21
        */
        blurChange(item,index,idx){
            this.basicIdx3 = index;
            let bool = true;
            let s =0;
            let hj =0;
            for(let i=0;i<item.day.length;i++){
                if(item.day[i]){
                    s+=1
                }
                hj+=item.day[i];
            }
            item.avg = hj?hj/s:0;
            if(bool){
                item.idx = index+1;
                item.cid = this.$route.query.course_id;
                this.saveBasic3();
            }
        },
        /*
         *@param: 
         *@return: 
         *@Description: 小组讨论提交数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-14 11:18:26
        */
        saveBasic4(){
            //调用加载中
            this.$emit('loadingHandle',true,"提交数据中...");
            let arr = deepCopy(this.groupDiscussion[this.basicIdx4].day);
            let o  = deepCopy(this.groupDiscussion[this.basicIdx4]);
            this.$delete(o,'day');
            for(let i=0;i<arr.length;i++){
                o[`day${i+1}`]=arr[i];
            }
            updateDIscStat(o).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.code==10002){
                    this.$toast(data.data.msg);
                    return
                }
                this.getData();
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 提交每日一问数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-13 16:56:52
        */
        saveBasic3(){
            //调用加载中
            this.$emit('loadingHandle',true,"提交数据中...");
            let arr = deepCopy(this.askADayList[this.basicIdx3].day);
            let o  = deepCopy(this.askADayList[this.basicIdx3]);
            this.$delete(o,'day');
            for(let i=0;i<arr.length;i++){
                o[`day${i+1}`]=arr[i];
            }
            updateQuizStat(o).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.code==10002){
                    this.$toast(data.data.msg);
                    return
                }
                this.getData();
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 添加小组讨论数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-13 16:53:11
        */
        addBasic4(l){
            let idx = this.groupDiscussion.length;
            this.$forceUpdate();
            if((!l &&this.groupDiscussion[0]&& this.groupDiscussion[0].idx==2)){
                this.groupDiscussion[0] = {
                    idx:1,
                    day:['',''],
                    avg:0, 
                }
            }else{
                if(l && String(l)){
                    this.groupDiscussion[l] = {
                        idx:l?l+1:idx+1,
                        day:['',''],
                        avg:0,           
                    }
                }else{
                    
                    this.groupDiscussion.push({
                        idx:idx+1,
                        day:['',''],
                        avg:0,           
                    });
                }
            }
        },
        /*
         *@param: 
         *@return: 
         *@Description: 添加每日一问数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-13 16:53:11
        */
        addBasic3(l){
            let idx = this.askADayList.length;
            this.$forceUpdate();
            if((!l && this.askADayList[0] &&  this.askADayList[0].idx==2)){
                this.askADayList[0] = {
                    idx:1,
                    day:['','','','',''],
                    avg:0, 
                }
            }else{
                if(l && String(l)){
                    this.askADayList[l] = {
                        idx:l?l+1:idx+1,
                        day:['','','','',''],
                        avg:0,           
                    }
                }else{
                    this.askADayList.push({
                        idx:idx+1,
                        day:['','','','',''],
                        avg:0,           
                    });
                }
            }
            
        },
        /*
         *@param: num 阿拉伯数字
         *@return: 
         *@Description: 转换数字汉字
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-13 16:28:05
        */
        conversion(num){
            return numberToChinese(parseInt(num));
        },
        /*
         *@param: 
         *@return: 
         *@Description: 拆分表头
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-10 18:26:22
        */
        splitTableHead(val){
            
            return val?val.split('：')[0]:''
        },
        /*
         *@param: 
         *@return: 
         *@Description: 请求接口
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-10 18:25:56
        */
        getData(){
            //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            // 基础数据
            if(this.activeTab=='basic1'){
                getBasicData({
                    course_id:this.$route.query.course_id
                }).then((data)=>{
                    this.list = data.list;
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                });
            }
            // 学院作业
            if(this.activeTab=='basic2'){
                getUserData({
                    course_id:this.$route.query.course_id
                }).then((data)=>{
                    this.level_list = data.level_list;
                    this.user_list = data.user_list;
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                });
            }
            // 每日一问
            if(this.activeTab=='basic3'){
                getQuizStatList({
                    cid:this.$route.query.course_id
                }).then((data)=>{
                    this.askADayList=[];
                    // 如果只有一个元素，就添加一行
                    if(data.list.length==1){
                        this.addBasic3(1);
                    }
                    // 如果数组为空默认两行
                    if(data.list.length==0){
                        for(let i =0;i<2;i++){
                            this.addBasic3(i);
                        }
                    }

                    // 添加默认的两行
                    let index = data.list.length-1;
                    let len = data.list.length>0?data.list[index].idx:0;
                    for(let i=1;i<=len;i++){
                        for(let u=0;u<data.list.length;u++){
                            if(i==data.list[u].idx){
                                this.$set(this.askADayList,i-1,deepCopy({
                                    id:data.list[u].id,
                                    idx:data.list[u].idx,
                                    day:this.dataHandle(data,u,5),
                                    avg:data.list[u].avg
                                }));
                                break;
                            }else{
                                this.$set(this.askADayList,i-1,deepCopy({
                                    idx:i,
                                    day:['','','','',''],
                                    avg:0
                                })); 
                            }
                        }
                        
                    }
                    
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                });
            }
            // 小组讨论
            if(this.activeTab=='basic4'){
                getDiscStatList({
                    cid:this.$route.query.course_id
                }).then((data)=>{
                    this.groupDiscussion=[];
                    // 如果只有一个元素，就添加一行
                    if(data.list.length==1){
                        this.addBasic4(1);
                    }
                    // 如果数组为空默认两行
                    if(data.list.length==0){
                        for(let i =0;i<2;i++){
                            this.addBasic4(i);
                        }
                    }
                    
                    // 添加默认的两行
                    let index = data.list.length-1;
                    let len = data.list.length>0?data.list[index].idx:0;
                    for(let i=1;i<=len;i++){
                        for(let u=0;u<data.list.length;u++){
                            if(i==data.list[u].idx){
                                this.$set(this.groupDiscussion,i-1,deepCopy({
                                    id:data.list[u].id,
                                    idx:data.list[u].idx,
                                    day:this.dataHandle(data,u,2),
                                    avg:data.list[u].avg
                                }));
                                break;
                            }else{
                                this.$set(this.groupDiscussion,i-1,deepCopy({
                                    idx:i,
                                    day:['',''],
                                    avg:0
                                })); 
                            }
                        }
                        
                    }


                    // let idx_ = null;
                    // for(let i=0;i<data.list.length;i++){
                    //     // 获得行数对应的下标
                    //     idx_ = data.list[i].idx-1;
                    //     // 存储行数,判断中间跳过了几行
                    //     let num = idx_-i;
                    //     if(num>=1){
                    //         for(let p=0;p<=num;p++){
                    //             this.$set(this.groupDiscussion,(idx_-num),{
                    //                 idx:data.list[i].idx-num,
                    //                 day:['',''],
                    //                 avg:0
                    //             });
                    //             num--;
                    //         }
                    //     }
                        
                    //     this.$set(this.groupDiscussion,idx_,{
                    //         id:data.list[i].id,
                    //         idx:data.list[i].idx,
                    //         day:this.dataHandle(data,i,2),
                    //         avg:data.list[i].avg
                    //     });
                        
                    // }
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                });
            }
            
            
        },
        /*
         *@param: 
         *@return: 
         *@Description: 处理数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-14 15:08:15
        */
        dataHandle(data,i,num){
            let arr = [];
            for(let y=1;y<=num;y++){
                arr.push(data.list[i][`day${y}`]);
            }
            return arr
        },
        /*
         *@param: index 下标 ,contentId 内容id
         *@return: 
         *@Description: 点击选项卡标题触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-10 16:19:31
        */
        toggleTab(idx,contentId){
            this.activeTab = contentId;
            this.getData();
        },
        /*
         *@param: 
         *@return: 
         *@Description: 初始化获取数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-10 16:20:01
        */
        pullData(){
            this.headList = [
                {
                    title:'基础数据',
                    contentId:'basic1'
                },
                {
                    title:'学员作业',
                    contentId:'basic2'
                },
                {
                    title:'每日一问数据',
                    contentId:'basic3'
                },
                {
                    title:'小组讨论数据',
                    contentId:'basic4'
                }

            ];
            this.getData();
            
        }
    },
    created() {
        this.pullData();
        shareCon("course", this);
    }
}
</script>

<style lang="scss">
.basic-data{
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #fff;
    overflow: auto;
    .tab-header{
        background-color: #F57F17;
        color: #fff;
        display: flex;
        line-height: 98px;
        label{
            display: block;
            font-size: 28px;
            margin-left: 40px;
            text-align: center;
            position: relative;
            img{
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
                width: 30px;
                height: 15px;
            }
        }
    }
    .tab-content{
        h3{
            margin: 50px 0 40px;
            color: #F57F17;
            font-size: 32px;
        }
        #basic1{
            padding: 0 30px;
            .table{
                border-collapse: collapse;
                width: 100%;
                tr.on{
                    line-height: 98px;
                    td{
                        font-size: 28px;
                    }
                }
                tr{
                    line-height: 80px;
                    &:nth-child(odd){
                        background:rgba(240,240,240,.5);
                    }
                }
                td{
                    border: 2px solid #F0F0F0;
                    text-align: center;
                    max-width: 257px;
                    padding: 0 25px;
                    font-size: 26px;
                    color: #333333;
                }
            }
            p{
                font-size: 24px;
                margin-top: 30px;
                color: #999999;
            }
        }
        #basic2{
            padding: 0 30px;
            .tb-group{
                display: flex;
                .left-tb,.right-tb{
                    table{
                        border-collapse: collapse;
                        tr:nth-child(odd){
                             background:rgba(240,240,240,.5);
                        }
                        tr:nth-child(1){
                            line-height: 97px;
                            height: 97px;
                            font-size: 28px;
                        }
                        tr:nth-child(2) td{
                            padding: 20px 0;
                        }
                        td{
                            border: 2px solid #F0F0F0;
                            text-align: center;
                            font-size: 26px;
                            color: #333333;
                            border-collapse: collapse;
                            img{
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                            }
                        }
                    }
                }
                .left-tb{
                    width: 223px;
                    table{
                        width: 100%;
                    }
                    td.on{
                        width: 144px;
                    }
                }
                .right-tb{
                    overflow-x: auto;
                    display: flex;
                    margin-left: -2px;
                    flex: 1;
                    table{
                        height:calc(100% - 1px); 
                    }
                    table td{
                        white-space: nowrap;
                        padding: 0 25px;
                        box-sizing: border-box;
                        a{
                            color: #F57F17;
                        }
                    }
                }
            }
        }
        // 每日一问
        #basic3,#basic4{
            padding: 0 30px;
            .tb-group{
                display: flex;
                .left-tb,.right-tb{
                    table{
                        border-collapse: collapse;
                        tr:nth-child(odd){
                             background:rgba(240,240,240,.5);
                        }
                        tr.tr2 td{
                            padding: 20px 0;
                        }
                        tr:nth-child(1){
                            line-height: 97px;
                            height: 97px;
                            font-size: 28px;
                        }
                        td{
                            border: 2px solid #F0F0F0;
                            text-align: center;
                            font-size: 26px;
                            color: #333333;
                            border-collapse: collapse;
                            height: 97px;
                            img{
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                            }
                            input{
                                width:110px;
                                box-sizing: border-box;
                                border: 0;
                                font-size: 26px;
                                padding: 0 40px;
                                background-color: transparent;
                            }
                        }
                    }
                }
                .left-tb{
                    width: 223px;
                    table{
                        width: 100%;
                    }
                    td{
                        padding: 0;
                    }
                    td.on{
                        width: 144px;
                    }
                }
                .right-tb{
                    overflow-x: auto;
                    display: flex;
                    margin-left: -2px;
                    flex: 1;
                    table{
                        height:calc(100% - 1px); 
                    }
                    table td{
                        white-space: nowrap;
                        padding: 0 25px;
                        box-sizing: border-box;
                        a{
                            color: #F57F17;
                        }
                    }
                }
            }
            .addBasic3,.addBasic4{
                display: flex;
                margin-top: 20px;
                color: #999999;
                img{
                    width: 36px;
                    height: 36px;
                    margin-right: 10px;
                }
                .two{
                    margin-left: 30px;
                }
            }
            p{
                font-size: 24px;
                text-align: justify;
                margin-top: 50px;
                color: #999999;
                margin-bottom: 80px;
            }
        }
        
    }
}
</style>